import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import logo from '../../images/logo-teal.svg';
import './Navbar.css';
import '../shared/UserAvatar.css';
import { NavigationUtils } from '../../util/NavigationUtils';
import { GLOBAL_PATH_PREFIX } from 'src/constants';
import AccountDropdown from './AccountDropdown';
import NotificationsDropdown from './NotificationsDropdown';
import NavbarIcon from './NavbarIcon';
import DaysLeftWrapper from '../shared/DaysLeftWrapper';

class NewDashboardNavbar extends React.Component {
  handleLogoClicked = ($event) => {
    // Don't let React Router handle our navigation
    // $event.preventDefault();
    // NavigationUtils.backToPopin();
  };

  render() {
    const { user } = this.props;
    const isPrioritize = true;
    const navbarStyle = `navbar navbar-expand navbar-light popin-navbar row fixed-top new-dashboard-navbar shadow-xs ${
      isPrioritize && 'prioritize'
    }`;
    const helpIcon = isPrioritize ? 'help_outline' : 'help';

    return (
      <nav className={navbarStyle}>
        <div className="align-items-center w-100 row no-gutters mr-3">
          <div className="nav-item ml-3">
            <Link
              onClick={this.handleLogoClicked}
              to={`${GLOBAL_PATH_PREFIX}/dashboard`}
            >
              <img
                src={logo}
                alt="POPin Navbar Logo"
                className="navbar-brand"
              />
            </Link>
          </div>

          <div className="fix-ie" />

          <div>
            <div className="row d-flex h-100">
              {!!user && (
                <div className="row no-gutters">
                  <div className="v-divider display-if-navbar-large-enough" />

                  <div className="v-divider" />

                  <DaysLeftWrapper plan={user.plan} />

                  <div className="v-divider" />

                  <NotificationsDropdown />

                  <NavbarIcon
                    tooltip="Help Center"
                    icon={helpIcon}
                    hideIfSmall={false}
                    handleClick={NavigationUtils.routeToSupport}
                  />
                </div>
              )}

              <div className="v-divider" />

              <AccountDropdown
                isEnterprise={false}
                location={this.props.location}
              />
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps, {})(NewDashboardNavbar);
